import React from 'react'
import { RecordView } from '../../../../../../shared/page/record-view'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { IconEdit, IconList } from '../../../../../../shared/icon/icon'
import { Menu, MenuDelete, MenuItem } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormApp } from '../../../../../../api-new/state/config'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'

export const AppEdit = () => {
  const { appID } = useParamsInt()

  const apiFormApp = useApiFormApp()

  const handlePath = () => apiFormApp.get(appID)

  const handleSubmit = data => apiFormApp.put(data.id, data)

  const roleSysApp = useRoleSysApp()

  const HeaderMenu = () =>
    <Menu>
      <MenuItem Icon={IconList} text="stores" to={`/admin/app/edit/${appID}/store`} show={roleSysApp.accessCreate} pin />
      <MenuDelete to={`/admin/app/edit/${appID}/delete`} show={roleSysApp.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <RecordView noun="app" back={{ label: 'Back to apps', to: '/admin/app' }} Icon={IconEdit} text={apiFormApp.form.name} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormApp.form.name} HeaderMenu={HeaderMenu}>
          <FormSimple state={apiFormApp.form} onSubmit={handleSubmit}>
            <FormSimpleText name="name" />
            <FormSimpleSubmitEdit backURL="/admin/app" />
          </FormSimple>
        </CardFullHeightScrollY>
      </RecordView>
    </React.Fragment>
  )
}
